import React, { FC, ReactNode } from 'react';
import { Typography } from '@mui/material';

type Props = {
  children: ReactNode;
};

/**
 * A group label inside a filter panel's list — "Domains", "Sub-domains" —
 * or atop the Scope type menu: the Figma Subtitle, helper text in grey-700,
 * inset to the rows' 12px padding.
 */
const FilterSubtitle: FC<Props> = ({ children }) => (
  <Typography
    variant="body2"
    color="grey.700"
    sx={{ px: '12px', pt: '8px', pb: '4px' }}
  >
    {children}
  </Typography>
);

export default FilterSubtitle;
